import "./AvailableEventsCount.css";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import InfoOutline from "~/content/icons/info-outline.svg?react";

export function AvailableEventsCount({ count }) {
  const { t } = useTranslation();

  if (!count || count < 1) {
    return null;
  }

  return (
    <section
      className="available-events-count"
      data-testid="available-events-count"
    >
      <InfoOutline
        aria-hidden="true"
        className="available-events-count__icon"
      />
      <p className="available-events-count__label">
        {t("home.available_events_count", { count })}
      </p>
    </section>
  );
}

AvailableEventsCount.propTypes = {
  count: PropTypes.number,
};
